import React from 'react'
import { Box, Text, Image,  VStack, Card, CardBody, Center, SimpleGrid } from '@chakra-ui/react'






const Labaratoriesandchemicalsolvents2 = () => {
  return (
    <>
     
      <Center>

        <Box mt='30px'>

          {/* HPLC Line 1 */}

          <Box >
            <Box m="10px" fontSize="18px">
              <Text as="b" color="#EB1414"> HPLC </Text>
            </Box>

            <Box mt="30px">
              {/* <VStack align="left" spacing="10px"> */}
              {/* <HStack spacing="10px"> */}
              <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={1}>
                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./peektubing.png' />
                          <Text as="b"> Peek Tubing </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./peektubingcutter.png' />
                          <Text as="b"> Peek Tubing Cutter </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./sstubingcutter.png' />
                          <Text as="b"> SS Tubing Cutter </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./peekferrules.png' />
                          <Text as="b"> Peek Ferrules </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>
                {/* </HStack>  */}

                {/* Line - 2 */}


                {/* <Box>  */}
                {/* <HStack spacing="10px"> */}
                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./ssunions.png' />
                          <Text as="b"> SS Unions </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./peekunions.png' />
                          <Text as="b"> Peek Unions </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./flukethermometers.png' />
                          <Text as="b"> Fluke thermometers </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./mobilephase.png' />
                          <Text as="b"> Mobile Phase Safety Caps </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                {/* </HStack> */}
                {/* </Box> */}

                {/* Line 3 */}

                {/* <HStack spacing="10px"> */}
                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./hplcdrain.png' />
                          <Text as="b"> HPLC Drain </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./vialrack.png' />
                          <Text as="b"> Vial Rack </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./workingstandard.png' />
                          <Text as="b"> WorkingStandard Vials </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./parafilm.png' />
                          <Text as="b"> Parafilm </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>
                {/* </HStack>  */}

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./hplcsolvents.png' />
                          <Text as="b"> HPLC Solvents </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>
              </SimpleGrid>
              {/* </VStack> */}
            </Box>
          </Box>


          {/* ---------- GC ------------ */}

          {/* <Box> */}
          <Box m="10px" fontSize="18px">
            <Text as="b" color="#EB1414"> GC </Text>
          </Box>

          {/* <Box mt="30px"> */}
          {/* <VStack align="left" spacing="10px"> */}
          {/* <HStack spacing="10px"> */}
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={1}>
            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./flatbottomvials.png' />
                      <Text as="b"> Flat Bottom Vials </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./roundbottomvials.png' />
                      <Text as="b"> Round Bottom Vials </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./20mmcrimpcamp.png' />
                      <Text as="b"> 20mm Crimp Cap & Septa </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./20mlscrewvials.png' />
                      <Text as="b"> 20ml Screw Vials </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            {/* </HStack> */}
            {/* </VStack> */}
            {/* </Box> */}
            {/* </Box> */}

            {/* Line 2 */}
            {/* <Box> */}

            {/* <Box> */}

            {/* <HStack spacing="10px"> */}
            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./20mmscrewcap.png' />
                      <Text as="b"> 20mm Screw Cap & Septa </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./crimper&decrimper.png' />
                      <Text as="b"> Crimper & Decrimper </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./hamilton.png' />
                      <Text as="b"> Hamilton & SGE </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./electroniccrimper.png' />
                      <Text as="b"> Electronic Crimper & Decrimper </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            {/* </HStack> */}

            {/* </Box> */}

            {/* </Box> */}


            {/* Line 3 */}
            {/* <Box > */}

            {/* <Box> */}

            {/* <HStack spacing="10px"> */}
            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./graphiteferrules.png' />
                      <Text as="b"> Graphite Ferrules </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./gccolumns.png' />
                      <Text as="b"> GC Columns Nuts </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./gchssolvents.png' />
                      <Text as="b"> GCHS Solvents </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./jets.png' />
                      <Text as="b"> Jets </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            {/* </HStack> */}

            {/* </Box> */}

            {/* </Box> */}

            {/* Line 4 */}
            {/* <Box > */}

            {/* <Box> */}

            {/* <HStack spacing="10px"> */}
            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./jets.png' />
                      <Text as="b"> Jets </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./liners.png' />
                      <Text as="b"> Liners </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./gccolumnunions.png' />
                      <Text as="b"> GC Column Union </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

            <Box>
              <Card height="300px" width="300px">
                <Center>
                  <CardBody m="5px" color="#756F6F">
                    <VStack>
                      <Image src='./11mmbto.png' />
                      <Text as="b"> 11 mm BTO Septa </Text>
                    </VStack>
                  </CardBody>
                </Center>
              </Card>
            </Box>

          </SimpleGrid>
          {/* </HStack> */}

          {/* </Box> */}
          {/* </Box>      */}


          {/* Dissolution */}

          {/* Line 1      */}

          {/* <Box> */}
          <Box m="10px" fontSize="18px">
            <Text as="b" color="#EB1414"> Dissolution </Text>
          </Box>

          <Box mt="30px">
            {/* <VStack align="left" spacing="10px"> */}
            {/* <HStack spacing="10px"> */}
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={1}>
              <Box>
                <Card height="300px" width="300px">
                  <Center>
                    <CardBody m="5px" color="#756F6F">
                      <VStack>
                        <Image src='./baskets.png' />
                        <Text as="b"> Baskets </Text>
                      </VStack>
                    </CardBody>
                  </Center>
                </Card>
              </Box>

              <Box>
                <Card height="300px" width="300px">
                  <Center>
                    <CardBody m="5px" color="#756F6F">
                      <VStack>
                        <Image src='./sinkers.png' />
                        <Text as="b"> Sinkers </Text>
                      </VStack>
                    </CardBody>
                  </Center>
                </Card>
              </Box>

              <Box>
                <Card height="300px" width="300px">
                  <Center>
                    <CardBody m="5px" color="#756F6F">
                      <VStack>
                        <Image src='./bdsyringes.png' />
                        <Text as="b"> BD Syringes </Text>
                      </VStack>
                    </CardBody>
                  </Center>
                </Card>
              </Box>

              <Box>
                <Card height="300px" width="300px">
                  <Center>
                    <CardBody m="5px" color="#756F6F">
                      <VStack>
                        <Image src='./glasssyringes.png' />
                        <Text as="b"> Glass Syringes </Text>
                      </VStack>
                    </CardBody>
                  </Center>
                </Card>
              </Box>
              {/* </HStack>  */}

              {/* Line - 2 */}


              {/* <Box mt="30px">  */}
              {/* <HStack spacing="10px"> */}
              <Box>
                <Card height="300px" width="300px">
                  <Center>
                    <CardBody m="5px" color="#756F6F">
                      <VStack>
                        <Image src='./cannulas.png' />
                        <Text as="b"> Cannulas </Text>
                      </VStack>
                    </CardBody>
                  </Center>
                </Card>
              </Box>

              <Box>
                <Card height="300px" width="300px">
                  <Center>
                    <CardBody m="5px" color="#756F6F">
                      <VStack>
                        <Image src='./canulafilters.png' />
                        <Text as="b"> Cannula Filters </Text>
                      </VStack>
                    </CardBody>
                  </Center>
                </Card>
              </Box>

              <Box>
                <Card height="300px" width="300px">
                  <Center>
                    <CardBody m="5px" color="#756F6F">
                      <VStack>
                        <Image src='./bdsyringes.png' />
                        <Text as="b"> BD Syringes </Text>
                      </VStack>
                    </CardBody>
                  </Center>
                </Card>
              </Box>

              <Box>
                <Card height="300px" width="300px">
                  <Center>
                    <CardBody m="5px" color="#756F6F">
                      <VStack>
                        <Image src='./glasssyringes.png' />
                        <Text as="b"> Glass Syringes </Text>
                      </VStack>
                    </CardBody>
                  </Center>
                </Card>
              </Box>
            </SimpleGrid>
            {/* </HStack> */}
            {/* </Box> */}
            {/* </VStack> */}
          </Box>

          {/* Consumables       */}

          <Box >
            <Box m="10px" fontSize="18px">
              <Text as="b" color="#EB1414"> Consumables </Text>
            </Box>

            <Box mt="30px">
              {/* <VStack align="left" spacing="10px"> */}
              {/* <HStack spacing="10px"> */}
              <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={1}>
                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./cryovials.png' />
                          <Text as="b"> Cryo Vials </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./agatemortar.png' />
                          <Text as="b"> Agate Mortar </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./cuvettes.png' />
                          <Text as="b"> Cuvettes </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./dishes.png' />
                          <Text as="b"> Dishes </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>
                {/* </HStack>  */}

                {/* Line - 2 */}


                {/* <Box>  */}
                {/* <HStack spacing="10px"> */}
                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./weighingpaper.png' />
                          <Text as="b"> Weighing Paper </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./weightbox.png' />
                          <Text as="b"> Weight Box </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./naclcells.png' />
                          <Text as="b"> Nacl Cells </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>

                <Box>
                  <Card height="300px" width="300px">
                    <Center>
                      <CardBody m="5px" color="#756F6F">
                        <VStack>
                          <Image src='./40mltocvials.png' />
                          <Text as="b"> 40 ml Toc Vials </Text>
                        </VStack>
                      </CardBody>
                    </Center>
                  </Card>
                </Box>
              </SimpleGrid>
              {/* </HStack> */}
              {/* </Box> */}
              {/* </VStack> */}
            </Box>

          </Box>
          {/* </Box> */}
        </Box>
      </Center>
    </>
  )
}

export default Labaratoriesandchemicalsolvents2;
